import React, { useState, useEffect } from 'react';
import styles from './ScalePreview.module.css';
import Icon from '../../Icon';
import cn from 'classnames';

interface ScaleProps {
  initialValue?: number;
  zoom: number;
  setZoom: (value: number) => void;
  minValue?: number;
  maxValue?: number;
}

const ScalePreview: React.FC<ScaleProps> = ({ 
  initialValue = 160,
  zoom,
  setZoom,
  minValue = 10,
  maxValue = 200
}) => {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(zoom);
  }, [zoom]);

  const handleIncrement = () => {
    if (value < maxValue) {
      const newValue = Math.min(value + 10, maxValue);
      setValue(newValue);
      setZoom(newValue);
    }
  };

  const handleDecrement = () => {
    if (value > minValue) {
      const newValue = Math.max(value - 10, minValue);
      setValue(newValue);
      setZoom(newValue);
    }
  };

  return (
    <div className={styles.control}>
      <button 
        className={styles.button}
        onClick={handleIncrement}
        disabled={value >= maxValue}
      >
        <Icon 
          name='scalePlus' 
          width='8' 
          height='8' 
          className={value >= maxValue ? styles.disabled_icon : ''}
        />
      </button>
      
      <span className={cn('cabtion-1-bold_font', styles.value)}>{value}%</span>
      
      <button 
        className={styles.button}
        onClick={handleDecrement}
        disabled={value <= minValue}
      >
        <Icon 
          name='scaleMinus' 
          width='8' 
          height='8' 
          className={value <= minValue ? styles.disabled_icon : ''}
        />
      </button>
    </div>
  );
};

export default ScalePreview;
